import { LicenseTypeNature } from '../../types';

import { type RootState } from '../index';

export const licenseTypesSelector =
  (licenseTypeNature: LicenseTypeNature = LicenseTypeNature.LPCO) =>
  (state: RootState) =>
    state.licenseType.licenseTypes[licenseTypeNature];
export const ogaStatusesSelector = (state: RootState) => state.licenseType.ogaStatuses;
